<!--
 * @Description: 医生-调查问卷 7 废
 * @Date: 2022-06-27 10:50:51
-->
<template>
  <div class>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="210px"
      class="ruleForm"
    >
      <submit-result
        :auditList="addEditMixin_auditList"
        :projectStatus="ruleForm.projectStatus"
      ></submit-result>
      <div class="xrk-project-form">
        <div>
          <xrk-subtitle>项目信息</xrk-subtitle>
          <el-form-item label="项目编码：" prop="projectName">
            <el-input v-model.trim="ruleForm.projectNo" disabled></el-input>
            <el-button
              type="primary"
              class="copyBtn_1"
              :data-clipboard-text="ruleForm.projectNo"
              @click="$copy('copyBtn_1')"
            >
              复制
            </el-button>
          </el-form-item>
          <el-form-item label="客户企业：" v-if="hasIndustry">
            <el-input
              disabled
              :value="ruleForm.industryEnterpriseName"
              v-if="hasIndustry"
            ></el-input>
          </el-form-item>
          <el-form-item label="项目名称：" prop="projectName">
            <el-input disabled v-model.trim="ruleForm.projectName"></el-input>
          </el-form-item>
          <el-form-item
            label="项目简介："
            prop="introduction"
            class="absoluteBox"
          >
            <el-input
              type="textarea"
              v-model.trim="ruleForm.introduction"
              placeholder="请输入项目简介"
              :rows="7"
              style="width:300px;"
              maxlength="200"
              :show-word-limit="true"
              :disabled="addEditMixin_introductionDisbaled"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="项目结算单价（不含税）："
            v-if="hasIndustry"
            prop="price"
          >
            <el-input
              :disabled="addEditMixin_disbaled"
              v-model="ruleForm.price"
            ></el-input>
            <span style="margin-left:10px;">元</span>
          </el-form-item>
          <el-form-item label="终端结算单价：" prop="csoPrice">
            <el-input
              :disabled="addEditMixin_disbaled"
              v-model.trim="ruleForm.csoPrice"
              :maxlength="11"
            ></el-input>
            <span style="margin-left:10px;">元</span>
          </el-form-item>
          <el-form-item label="税率：" v-if="hasIndustry" prop="contractScale">
            <el-input
              :disabled="addEditMixin_disbaled"
              v-model.trim="ruleForm.contractScale"
            ></el-input>
            <span style="margin-left:10px;">%</span>
            <!-- {{ ruleForm.contractScale | transScale }} -->
          </el-form-item>
          <!-- <el-form-item label="总任务量：" prop="taskSum" v-if="hasIndustry">
          <el-input disabled :value="ruleForm.taskSum || 0" v-if="hasIndustry"></el-input>
        </el-form-item>-->
          <el-form-item label="背景需求：" prop="projectBackground">
            <el-select
              v-model="ruleForm.projectBackground"
              :disabled="addEditMixin_disbaled"
              placeholder="请选择背景"
              @change="addEditMixin_validateBackground"
            >
              <el-option
                v-for="item in addEditMixin_backgroundList"
                :key="item.id"
                :value="item.id"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="总任务量：" prop="taskSumCount">
            <el-input disabled :value="ruleForm.taskSumCount || 0"></el-input>
          </el-form-item>
          <el-form-item label="已完成任务量：">
            <el-input disabled :value="ruleForm.finishSumCount || 0"></el-input>
          </el-form-item>
          <el-form-item label="审核人员对其可见：">
            <reviewer
              :disabled="addEditMixin_disbaled"
              :info="ruleForm"
            ></reviewer>
          </el-form-item>
          <!--1 项目执行人脱敏规则：-->
          <tm-execute-name-rule
            v-model="ruleForm.tmExecuteNameRule"
            :disabled="addEditMixin_disbaled"
          />
        </div>
        <div>
          <xrk-subtitle>需求信息</xrk-subtitle>
          <el-form-item label="项目图片：" prop="bgUrl">
            <GenerateImage
              :initUrl="ruleForm.bgUrl"
              :oldUrl="ruleForm.oldBgUrl"
              :initType="ruleForm.bgUrlSource"
              @done="addEditMixin_finishUpload"
              @finish="addEditMixin_finishUpload"
              @changeType="addEditMixin_changeBgType"
              :auditStatus="ruleForm.auditStatus"
              :disabled="addEditMixin_disbaled"
            ></GenerateImage>
          </el-form-item>
          <ul class="pic-wrap">
            <el-form-item label="照片描述：" prop="projectImg">
              <li
                v-for="(item, index) in ruleForm.projectImg"
                :key="index"
                class="sampleBox"
              >
                <el-input
                  type="textarea"
                  :rows="3"
                  :disabled="addEditMixin_disbaled"
                  v-model.trim="ruleForm.projectImg[index]"
                  maxlength="100"
                  style="width:300px;"
                  show-word-limit
                ></el-input>
                <el-button
                  class="pic-button"
                  @click="delImgList(index)"
                  v-show="index > 0"
                  :disabled="addEditMixin_disbaled"
                >
                  删除
                </el-button>
              </li>
              <div style="min-height: 30px">
                <!--新增按钮隐藏后支撑高度-->
                <el-button
                  class="pic-button add-button"
                  @click="pushImgList"
                  v-show="ruleForm.projectImg.length < 10"
                  :disabled="addEditMixin_disbaled"
                >
                  新增
                </el-button>
              </div>
            </el-form-item>
          </ul>
          <el-form-item
            label="订单支付审核："
            v-if="ruleForm.isOrderAudit == 1"
          >
            <el-button
              plain
              style="color: #3a8ee6;border-color: #3a8ee6;cursor: default;"
            >
              需审核
            </el-button>
            <span>
              项目支付给自然人时需进行审核
            </span>
          </el-form-item>
          <el-form-item label="职业认证：" prop="isOccupationAuth">
            <el-radio-group
              v-model="ruleForm.isOccupationAuth"
              :disabled="addEditMixin_disbaled"
            >
              <el-radio
                border
                class="auth-type"
                :label="item.type"
                v-for="(item, index) in isOccupationAuthArray"
                :key="`way${index}`"
              >
                {{ item.value }}
              </el-radio>
            </el-radio-group>
            <div
              v-if="ruleForm.isOccupationAuth"
              class="is-occupation-auth"
              style="display:flex;margin-top:20px"
            >
              <div>
                <el-form-item
                  label-width="110px"
                  label="认证类型："
                  prop="occupationType"
                >
                  <!-- <span>认证类型：</span> -->
                  <span>
                    <el-select
                      style="width:30%"
                      v-model="ruleForm.occupationType"
                      :disabled="addEditMixin_disbaled"
                      placeholder="请选择认证类型"
                    >
                      <el-option
                        v-for="item in occupationTypeArray"
                        :key="item.id"
                        :value="item.id"
                        :label="item.label"
                      ></el-option>
                    </el-select>
                  </span>
                </el-form-item>
              </div>
              <div style="margin-left:20px">
                <el-form-item label-width="0" prop="occupationAuthMode">
                  <el-radio-group
                    v-model="ruleForm.occupationAuthMode"
                    :disabled="addEditMixin_disbaled"
                  >
                    <el-radio
                      border
                      class="auth-type"
                      :label="item.type"
                      v-for="(item, index) in occupationAuthModeArray"
                      :key="`way${index}`"
                    >
                      {{ item.value }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            label="C端图片查重："
            v-if="addEditMixin_repeatFormItemEnabled"
            prop="isCPicRepeat"
          >
            <el-radio-group
              v-model="ruleForm.isCPicRepeat"
              :disabled="addEditMixin_disbaled"
            >
              <el-radio border class="auth-type" :label="1">
                是
              </el-radio>
              <el-radio border class="auth-type" :label="0">
                否
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- <common-items :disabled="addEditMixin_disbaled" />-->
          <el-form-item
            v-for="(ele, i) in addEditMixin_formItems"
            :label="ele.label"
            :key="i"
            :prop="ele.prop"
          >
            <el-input
              v-model="ruleForm[ele.prop]"
              :disabled="addEditMixin_disbaled"
              v-bind="ele"
            >
              <template #append>
                {{ ele.suffix }}
                <el-tooltip placement="top" effect="light">
                  <div slot="content" v-html="ele.content"></div>
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
            </el-input>
          </el-form-item>
        </div>
      </div>
      <div class="xrk-project-footer">
        <template v-if="addEditMixin_showSaveBtn">
          <el-button
            type="primary"
            plain
            @click="addEditMixin_submitForm('ruleForm')"
            :loading="btLoading"
            :disabled="addEditMixin_disbaled"
          >
            保存
          </el-button>
          <submit-verify-btn
            @finish="addEditMixin_finishSubmit"
            :auditStatus="ruleForm.auditStatus"
            :ifDis="addEditMixin_disbaled"
          ></submit-verify-btn>
        </template>
        <el-button
          type="primary"
          plain
          v-if="addEditMixin_showAginEditBtn"
          @click="addEditMixin_onAginEditProject(ruleForm)"
          :loading="btLoading"
          :disabled="addEditMixin_aginEditBtnDisabled"
        >
          再次编辑
        </el-button>
        <template v-if="addEditMixin_showAginSaveBtn">
          <el-button
            type="primary"
            plain
            @click="addEditMixin_cancelEditProject('ruleForm')"
          >
            取消
          </el-button>
          <el-button
            type="primary"
            plain
            @click="addEditMixin_confirmEditProject('ruleForm')"
            :loading="btLoading"
          >
            提交审核
          </el-button>
        </template>
        <submit-verify-and-next-btn
          :info="ruleForm"
          :submitFn="addEditMixin_finishSubmit"
        ></submit-verify-and-next-btn>
      </div>
    </el-form>
  </div>
</template>
<script>
import { projectV2 } from '@/api/ajax';
import { courseType, whetherOrNot } from '@/config/staticData';

import { moneyComplete, moneyInt } from '@/tools/money';

import addEdit from '@/page/project-classify/src/mixins/add-edit';

export default {
  name: 'zsCase',
  mixins: [addEdit],
  data() {
    const vilidatorImgList = (rule, value, callback) => {
      let error = false;
      value.length === 0 && (error = true);
      value.forEach(item => {
        !item && (error = true);
      });
      if (error) {
        callback(new Error('图片描述不能为空'));
      } else {
        callback();
      }
    };
    return {
      backgroundFlag: false,
      ifDisable: false,
      whetherOrNot,
      courseType,
      defaultObj: null,
      priceFlag: false, //价格是否可编辑
      prop: {
        label: 'enterpriseName',
        code: 'id'
      },
      initSummary: '',
      initRoleImg: '',
      initProgram: '',
      fuckShow: [
        { label: '是', value: 1 },
        { label: '否', value: 2 }
      ],
      ruleForm: {
        introduction: '',
        projectType: 18, // 1学术拜访  2 OTC巡访  3 科室会  4 患教会 5 助手调查问卷  6 专区  7医生调查问卷  8病例
        projectStatus: 0,
        id: this.$route.query.id,
        bingliCount: 2,
        enterpriseId: '',
        projectName: '',
        taskSum: '',
        price: '',
        csoPrice: '',
        bgUrl: '',
        projectImg: [],
        auditStatus: '',
        isCPicRepeat: '0'
      },
      // 校验
      rules: {
        projectDesensitizationRule: [
          {
            required: true,
            message: '请选择脱敏规则',
            trigger: 'blur'
          }
        ],
        projectBackground: [
          {
            required: true,
            message: '请选择背景',
            trigger: 'blur'
          }
        ],
        isCPicRepeat: [
          {
            required: true,
            message: '请选择C端图片是否查重',
            trigger: 'blur'
          }
        ],

        introduction: [
          {
            max: 200,
            required: true,
            message: '请填写项目简介，最多200个字符',
            trigger: 'blur'
          }
        ],
        taskSum: [
          {
            required: true,
            message: '甲方未填写总任务量',
            trigger: 'blur'
          }
        ],
        enterpriseId: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }
        ],
        bgUrl: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }
        ],
        projectName: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }
        ],
        projectImg: [
          {
            required: true,
            validator: vilidatorImgList,
            trigger: 'blur'
          }
        ]
      }
    };
  },

  methods: {
    addEditMixin_validateBackground() {
      this.$refs.ruleForm.validateField('projectBackground', () => {});
    },
    finishUpload(v) {
      this.ruleForm.bgUrl = v;
    },
    addEditMixin_finishSubmit(type) {
      //审核提交
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            this.$confirm(
              this.hasIndustry
                ? '请您确认提交当前信息至后台审核，审核通过且待甲方确认无误后您将可以继续执行项目。'
                : '请您提交当前信息至后台审核，审核通过后您将可以继续执行项目。',
              '提示',
              {
                confirmButtonText: '确认提交',
                cancelButtonText: '取消',
                type: 'warning'
              }
            )
              .then(() => {
                projectV2
                  .submitProjectAudit({
                    ...this.ruleForm,
                    csoPrice: moneyComplete(this.ruleForm.csoPrice),
                    price: moneyComplete(this.ruleForm.price),
                    type: type
                  })
                  .then(() => {
                    resolve('submit_success');
                    this.$message({
                      type: 'success',
                      message: '已提交审核',
                      onClose: function() {
                        window.location.reload();
                      }
                    });
                  })
                  .catch(() => {
                    reject('submit_error');
                  });
              })
              .catch(() => {
                reject('submit_error');
                this.$message({
                  type: 'info',
                  message: '已取消'
                });
              });
          } else {
            reject('submit_error');
            return false;
          }
        });
      });
    },
    pushImgList() {
      this.ruleForm.projectImg.push('');
    },
    delImgList(index) {
      this.ruleForm.projectImg.splice(index, 1);
    },
    contentChange(v) {
      this.ruleForm.lecturerIntroduction = v;
    },
    resetForm() {
      // this.$router.push({
      //   name: "assign",
      //   query: {
      //     id: this.$route.query.id
      //   }
      // });
    },
    saveFCategoryId(val) {
      this.ruleForm.enterpriseId = val.id;
      this.ruleForm.platformId = val.platformId;
    },
    waitPicDone(v) {
      this.ruleForm.bgUrl = v;
    },
    addEditMixin_submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 混合对象 格式化数据
          let cbEvent = () => {
            projectV2
              .addUpdateProjectV2({
                ...this.ruleForm,
                csoPrice: moneyComplete(this.ruleForm.csoPrice),
                price: moneyComplete(this.ruleForm.price)
              })
              .then(() => {
                this.$notify({
                  title: '成功',
                  message: '保存成功',
                  type: 'success'
                });
                this.$emit('resetRuleForm', this.ruleForm);
                this.resetForm();
              });
          };
          if (this.priceFlag == false) {
            this.makeSureEvent(cbEvent);
          } else {
            cbEvent();
          }
        } else {
          return false;
        }
      });
    }
  },
  created() {
    if (this.$route.query.id) {
      projectV2
        .loadProjectV2({
          id: this.$route.query.id,
          projectType: this.ruleForm.projectType
        })
        .then(res => {
          let {
            tXcxProject,
            projectImg,
            taskSumCount,
            finishSumCount,
            tXcxProjectUpdate
          } = res.data.data;
          tXcxProject.price = moneyInt(tXcxProject.price);
          tXcxProject.csoPrice = moneyInt(tXcxProject.csoPrice);
          Object.assign(this.ruleForm, tXcxProject, { projectImg });

          this.addEditMixin_setIntroductionAuditStatusToAuditList(
            tXcxProjectUpdate
          );
          this.ruleForm = Object.assign({}, this.ruleForm, {
            taskSumCount,
            finishSumCount
          });
          // 图片查重设置默认值
          if (
            'isCPicRepeat' in this.ruleForm &&
            +this.ruleForm.isCPicRepeat !== 0 &&
            +this.ruleForm.isCPicRepeat !== 1
          ) {
            this.ruleForm.isCPicRepeat = 1;
          }
          this.ruleForm.projectImg.length === 0
            ? this.ruleForm.projectImg.push('')
            : '';

          this.$emit('resetRuleForm', this.ruleForm);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.pic-wrap {
  // margin-bottom: -20px;
  li {
    margin-bottom: 20px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  .pic-button {
    border: none;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #5a9cf8;
    line-height: 14px;

    &:hover {
      background-color: transparent;
    }

    &.add-button {
      background-color: transparent;
      padding: 0;
      margin-top: -9px;
    }
  }

  .sampleBox {
    display: flex;
  }
}
</style>
